import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-talent-hub',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class TalentHubComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
